import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormLabel,
  Heading,
  Stack,
  Switch,
  useToast,
  VStack,
  FormControl,
  FormErrorMessage,
  Box,
  Input,
  Divider,
  IconButton,
  InputGroup,
  InputRightElement,
  // Checkbox,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  HStack,
  Text,
  Spinner,
  Select,
} from "@chakra-ui/react";
import { Formik, Form, Field, FieldProps, FormikProps } from "formik";
import { CorbanFormValidationSchema } from "./corbanFormValidation";
import { useEffect, useRef, useState } from "react";
import BackButton from "../BackButton";
import { documentFormatter } from "@/utils/documentFormatter";
import { getBanks } from "../../services/bank.service";
import { Bank } from "@/models/bank.model";
import { cpfFormatter } from "@/utils/cpfFormatter";
import { formatPhone } from "@/utils/formatPhone";
import WhiteLabelForm from "../WhiteLabelForm";
import FinancialSettingsForm from "../FinancialSettingsForm";
import { getRoles } from "@/services/role.service";
import { Role } from "@/models/role.model";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { getAllProducts } from "@/services/product.service";
import { Product } from "@/models/product.model";
import { PermissionEnum } from "@/utils/permissionEnum";

import { reseConsigntWebhook, resetApiKeyConsig, resetApiKeyFGTS, resetFGTSWebhook } from "@/services/corban.service";

import { ConsigProduct } from "@/models/consignado-product.model";
import { getConsigAllProducts } from "@/services/consignado/product.service";
import { User } from "@/models/user.model";
import { getCommercialManagers } from "@/services/user.service";
import CertifiedCpfSelector from "@/components/CertifiedCpfSelector";

interface CorbanFormProps {
  initialValues: any;
  onSubmit: (values: any) => Promise<void>;
  isNew: boolean;
  commercialManagerId?: string | null;
  creditPromoterId?: number | null;
}

export default function CorbanForm({
  initialValues,
  onSubmit,
  isNew,
  commercialManagerId,
  creditPromoterId,
}: CorbanFormProps) {

  const [roles, setRoles] = useState<{
    corbanWithoutPromoter?: Role | null;
    canCreateUser?: Role | null;
    cannotCreateUser?: Role | null;
  }>({
    corbanWithoutPromoter: null,
    canCreateUser: null,
    cannotCreateUser: null,
  });

  const formikRef = useRef<FormikProps<any>>(null);
  const [isZeCredito, setIsZeCredito] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isRoleSwitchEnabled, setIsRoleSwitchEnabled] = useState(false);
  const [banks, setBanks] = useState<Bank[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loadingBanks, setLoadingBanks] = useState(false);
  // const [isSavingProducts, setIsSavingProducts] = useState<boolean>(false);
  // const [selectedConsigProducts, setSelectedConsigProducts] = useState<ConsigProduct[]>(
  //   []
  // );
  // const [selectedFgtsProducts, setSelectedFgtsProducts] = useState<Product[]>([]);
  const [isFGTSProductsLoading, setIsFGTSProductsLoading] = useState<boolean>(false);
  const [isConsigProductsLoading, setIsConsigProductsLoading] = useState<boolean>(false);

  const [showApiKey, setShowApiKey] = useState<boolean>(false);
  const [showConsigApiKey, setConsigApiKey] = useState<boolean>(false);
  const [consigProducts, setConsigProducts] = useState<ConsigProduct[]>([]);
  const [isUpdatingFgtsWebhook, setIsUpdatingFgtsWebhook] = useState<boolean>(false);
  const [isUpdatingConsigWebhook, setIsUpdatingConsigWebhook] = useState<boolean>(false);
  const toast = useToast();

  const effectiveCreditPromoterId =
    creditPromoterId ||
    initialValues.creditPromoterId ||
    initialValues.creditPromoter?.id;

  const [isWhiteLabelEnabled, setIsWhiteLabelEnabled] = useState(
    !!initialValues.whiteLabelId
  );

  const hasPromoter = !!(effectiveCreditPromoterId || creditPromoterId || initialValues.creditPromoterId);

  const [isFGTSEnable, setIsFGTSEnable] = useState(hasPromoter ? !!initialValues?.isFGTSEnablePromoter : !!initialValues?.isFGTSEnable);
  const [isConsigEnable, setIsConsigEnable] = useState(hasPromoter ? !!initialValues?.isConsigEnablePromoter : !!initialValues?.isConsigEnable);
  const [commercialManagers, setCommercialManagers] = useState<User[]>([]);
// console.log("commercialManagerIdCorbanForm", initialValues.commercialManagerId);
// console.log("creditPromoterId", creditPromoterId);
  const effectiveCommercialManagerId =
    initialValues.commercialManagerId ??
    commercialManagerId ??
    null;
    // console.log("effectiveCommercialManagerId", effectiveCommercialManagerId);
  function verifyIsZeCredito() {
    if (initialValues.id == 3) {
      setIsZeCredito(true);
      return true;
    }
    return false;
  }

  function verifyIsTokReal() {
    if (!hasPromoter) {
      return false;
    }
    if (creditPromoterId == 14 || initialValues.creditPromoterId == 14) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });

    const fetchData = async () => {
      setLoadingBanks(true);
      try {
        const rolesData = await getRoles();

        setRoles({
          corbanWithoutPromoter: rolesData.find(
            (role) => role.name === "MASTER_CORBAN_SEM_PROMOTORA"
          ),
          canCreateUser: rolesData.find(
            (role) => role.name === "MASTER_CORBAN_COM_PROMOTORA"
          ),
          cannotCreateUser: rolesData.find(
            (role) => role.name === "MASTER_CORBAN_COM_PROMOTORA_SEM_CADASTRO"
          ),
        });
        const managersList = await getCommercialManagers();
        setCommercialManagers(managersList);
        const banksList = await getBanks(1, 9999);
        if (banksList) {
          setBanks(banksList.data)
        }
      } catch (err: any) {
        toast({
          title: "Erro ao carregar dados",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setLoadingBanks(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (initialValues) {
      // Atualiza os estados locais assim que o initialValues for preenchido
      setIsFGTSEnable(hasPromoter ? !!initialValues?.isFGTSEnablePromoter : !!initialValues?.isFGTSEnable);
      setIsConsigEnable(hasPromoter ? !!initialValues?.isConsigEnablePromoter : !!initialValues?.isConsigEnable);
    }
  }, [initialValues]);

  useEffect(() => {
    if (!isFGTSEnable) return;
    const fetchData = async () => {
      setIsFGTSProductsLoading(true)
      const products = await getAllProducts(1, 9999);
      let filteredProducts = products.data;
      if (!verifyIsTokReal()) {
        filteredProducts = filteredProducts.filter(
          (p: Product) => p.name !== "GRANATOK 1" && p.name !== "GRANATOK 2"
        );
      }
      if (!verifyIsZeCredito()) {
        filteredProducts = filteredProducts.filter(
          (p: Product) => p.name !== "ZERO TAC ZDC"
        );
      }

      setProducts(filteredProducts);

      if (formikRef.current) {
        const currentSelected = formikRef.current.values.products || [];

        if (currentSelected.length === 0) {
          // IDs de referência
          // '75437dc2-ea1d-43b6-8150-cf16491192f2' -> LIGHT
          // '3c4489bd-e2a1-4299-ae99-8866e28b435d' -> NORMAL
          // '636a2d95-265c-40f1-a0ff-d87daecc9199' -> POWER
          // '3369641e-3e71-4a27-baac-11b4b9f5ccfc' -> MAX
          // '94a29c7f-f6aa-4b06-ba89-8e423a888f1a' -> ULTRA
          const defaultFGTSProductNames = ["LIGHT", "NORMAL", "POWER", "MAX", "ULTRA"];
          const defaultFGTSProducts = filteredProducts.filter((p: Product) =>
            defaultFGTSProductNames.includes((p.name || "").toUpperCase())
          );

          formikRef.current.setFieldValue('products', defaultFGTSProducts);
          // setSelectedFgtsProducts(filteredProducts);
        }
      }

      setIsFGTSProductsLoading(false)
    }

    fetchData()
  }, [isFGTSEnable]);

  useEffect(() => {
    if (!isConsigEnable) return;
    const getConsigProducts = async () => {
      try {
        setIsConsigProductsLoading(true);
        const consigProductsList = await getConsigAllProducts();
        setConsigProducts(consigProductsList);

        if (formikRef.current) {
          const currentSelected = formikRef.current.values.consigProducts || [];

          if (isNew || currentSelected.length === 0) {
            const formattedProducts = consigProductsList.map(p => ({
              productId: p.id,
              corbanId: initialValues.id,
              ...p
            }));

            formikRef.current.setFieldValue('consigProducts', formattedProducts);
            // setSelectedConsigProducts(formattedProducts);
          }
        }
      } catch (error) {
        console.error("Erro ao buscar produtos consignados:", error);
      } finally {
        setIsConsigProductsLoading(false)
      }
    };

    getConsigProducts();
  }, [isConsigEnable]);

  useEffect(() => {
    if (!formikRef.current) return;

    // Define as regras de proibição
    const isFGTSForbidden = hasPromoter && !initialValues?.isFGTSEnablePromoter;
    const isConsigForbidden = hasPromoter && !initialValues?.isConsigEnablePromoter;

    // 1. Limpeza do FGTS
    if (isFGTSForbidden) {
      // Se tiver produtos selecionados, limpa o array
      if (formikRef.current.values.products?.length > 0) {
        formikRef.current.setFieldValue('products', []);
        // setSelectedFgtsProducts([]); // Atualiza seu state local visual se estiver usando
      }
      // Se o switch estiver 'true' (vindo do banco), força 'false'
      if (formikRef.current.values.isFGTSEnable) {
        formikRef.current.setFieldValue('isFGTSEnable', false);
        setIsFGTSEnable(false); // Atualiza o state local do switch
      }
    }

    // 2. Limpeza do Consignado
    if (isConsigForbidden) {
      // Se tiver produtos selecionados, limpa o array
      if (formikRef.current.values.consigProducts?.length > 0) {
        formikRef.current.setFieldValue('consigProducts', []);
        // setSelectedConsigProducts([]); // Atualiza seu state local visual se estiver usando
      }
      // Se o switch estiver 'true' (vindo do banco), força 'false'
      if (formikRef.current.values.isConsigEnable) {
        formikRef.current.setFieldValue('isConsigEnable', false);
        setIsConsigEnable(false); // Atualiza o state local do switch
      }
    }
  }, [hasPromoter, initialValues]);

  // async function updateCreditTypeCorban(values: any) {
  //   setIsSavingProducts(true);
  //   try {
  //     await updateCreditType({
  //       corbanId: initialValues.id,
  //       credit_type: CorbanCreditModalityEnum.FGTS,
  //       api_enable: values?.isFGTSApiEnable,
  //       enable: values?.isFGTSEnable,
  //       userCanAccess: values?.isFGTSEnable ? 'all' : ''
  //     });

  //     await updateCreditType({
  //       corbanId: initialValues.id,
  //       credit_type: CorbanCreditModalityEnum.CONSIG_WORKER,
  //       api_enable: values?.isConsigApiEnable,
  //       enable: values?.isConsigEnable,
  //       userCanAccess: values?.isConsigEnable ? 'all' : ''
  //     });

  //     const corbanId = parseInt(initialValues.id);

  //     await updateCorbanProduct(corbanId, {
  //       consig_products: selectedConsigProducts,
  //       fgts_products: selectedFgtsProducts,
  //     });

  //     if (values.isCreateAccessApiGranatechFgts && values.fgtsWebhookUrl) {
  //       await createAccessApiGranatechFgts({
  //         webhookFgts: values.fgtsWebhookUrl,
  //         corbanId: values.id,
  //         granatechUserId: values.masterUserId,
  //         fgtsToken: values.fgtsToken,
  //       });
  //     }

  //     if (values.isCreateAccessApiGranatechConsig && values.consigWebhookUrl) {
  //       await createAccessApiGranatechConsig({
  //         webhookConsig: values.consigWebhookUrl,
  //         corbanId: values.id,
  //         granatechUserId: values.masterUserId,
  //         consigToken: values.consigToken,
  //       });
  //     }

  //     toast({
  //       title: "Sucesso",
  //       description:
  //         "Configurações de produtos salvas! para o corban id: " + initialValues.id,
  //       status: "success",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //     setIsSavingProducts(false);
  //   } catch (error) {
  //     console.error("Error creating credit type:", error);
  //     toast({
  //       title: "Erro",
  //       description: "Erro ao salvar configurações",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // }

  // const createAccessApiGranatechFgts = async (params: {
  //   webhookFgts: string,
  //   corbanId: number,
  //   granatechUserId: string,
  //   fgtsToken: string,
  // }) => {
  //   try {
  //     const masterUser: User = {
  //       id: initialValues?.masterUserId,
  //     } as User;
  //     await resetPassword(masterUser);

  //     await createUserApiFGTS({
  //       webhook_fgts: params.webhookFgts,
  //       corban_id: params.corbanId,
  //       granatech_user_id: params.granatechUserId,
  //       granatech_password_id: 'mudar123',
  //       token: params.fgtsToken,
  //     })
  //   } catch (error) {
  //     console.error('Error at updating webhook for fgts', error)
  //   }
  // }
  // const createAccessApiGranatechConsig = async (params: {
  //   webhookConsig: string,
  //   corbanId: number,
  //   granatechUserId: string,
  //   consigToken: string,
  // }) => {
  //   try {
  //     const masterUser: User = {
  //       id: initialValues?.masterUserId,
  //     } as User;
  //     await resetPassword(masterUser);

  //     await createUserApiConsig({
  //       webhook_consignado: params.webhookConsig,
  //       corban_id: params.corbanId,
  //       granatech_user_id: params.granatechUserId,
  //       granatech_password_id: 'mudar123',
  //       token: params.consigToken,
  //     })
  //   } catch (error) {
  //     console.error('Error at updating webhook for fgts', error)
  //   }
  // }

  const handleResetFGTSApiKey = async (setFieldValue: any) => {
    try {
      const response = await resetApiKeyFGTS({ granatech_user_id: initialValues?.masterUserId })
      setFieldValue('fgtsApikey', response?.api_key)
    } catch (error) {
      console.error('Error at reseting api key for fgts', error)
    }
  }

  const handleResetConsigApiKey = async (setFieldValue: any) => {
    try {
      const response = await resetApiKeyConsig({ granatech_user_id: initialValues?.masterUserId })
      setFieldValue('consigApikey', response?.api_key)
    } catch (error) {
      console.error('Error at reseting api key for consignado', error)
    }
  }

  const handleResetFGTSWebhook = async (values: any) => {
    setIsUpdatingFgtsWebhook(true);
    try {
      await resetFGTSWebhook({ granatech_user_id: initialValues?.masterUserId, webhook_fgts: values.fgtsWebhookUrl, token: values.fgtsToken })
      toast({
        title: "Sucesso",
        description: "Webhook FGTS atualizado com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error at updating webhook for fgts', error)
      toast({
        title: "Erro",
        description: "Erro ao atualizar webhook FGTS",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsUpdatingFgtsWebhook(false);
    }
  }

  const handleResetConsigWebhook = async (values: any) => {
    setIsUpdatingConsigWebhook(true);
    try {
      await reseConsigntWebhook({ granatech_user_id: values?.masterUserId, webhook_consignado: values.consigWebhookUrl, token: values.consigToken })
      toast({
        title: "Sucesso",
        description: "Webhook Consignado atualizado com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error at updating webhook for consignado', error)
      toast({
        title: "Erro",
        description: "Erro ao atualizar webhook Consignado",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsUpdatingConsigWebhook(false);
    }
  }

  function isFinancialConfigurationInvalid(values: any, hasPromoter: boolean, isSubmitting: boolean): boolean {
    // console.log("CorbanForm:isFinancialConfigurationInvalid", values)
    // console.log("CorbanForm:isFinancialConfigurationInvalid hasPromoter", hasPromoter)
    // console.log("CorbanForm:isFinancialConfigurationInvalid isSubmitting", isSubmitting)
    if (isSubmitting) return true;

    const financialInvalid =
      (values.isFGTSEnable || values.isConsigEnable) &&
      (
        (!hasPromoter && !values.financialSettingsId) ||
        (hasPromoter && values.paymentSplit && !values.financialSettingsId)
        // ||(hasPromoter && values.paymentSplit && !initialValues.financialSettingsCorban)
      );
    //   console.log("inicialValues.financialSettingsCorban", initialValues.financialSettingsCorban)
    //  console.log("CorbanForm:isFinancialConfigurationInvalid", financialInvalid)
    return financialInvalid
  }

  return (
    <Flex direction="column" width="100%">
      <BackButton />

      <Card width="100%" display="flex" flexDir="column">
        <CardHeader width="100%">
          <Stack spacing={6}>
            <Heading fontFamily="Lexend Deca" fontSize="3xl" as="b">
              {isNew ? "Adicionar Corban" : "Editar Corban"}
            </Heading>

            <Flex alignItems='center' gap={4}>
              {!isNew && (
                <Heading as="b" size="md">
                  Id do Corban - {initialValues.id}
                </Heading>
              )}
              {hasPromoter && (
                <Box bg='gray.300' px={5} py={1.5} rounded='lg'>
                  <Text>
                    {`Promotora: ${initialValues?.creditPromoterId} - ${initialValues?.creditPromoter?.businessName}`}
                  </Text>
                </Box>
              )}
            </Flex>

          </Stack>
        </CardHeader>

        <CardBody height="100%" pt={1}>
          <Formik
            innerRef={formikRef}
            initialValues={{
              ...initialValues,
              commercialManagerId: effectiveCommercialManagerId,
            }}
            enableReinitialize
            onSubmit={async (values, formikHelpers) => {
              // Validação manual do gerente comercial (sem Yup)
              if (!hasPromoter && (
                typeof values.commercialManagerId === "undefined" ||
                values.commercialManagerId === "" || values.commercialManagerId === null)
              ) {
                formikHelpers.setFieldError(
                  "commercialManagerId",
                  "Selecione o Gerente Comercial",
                );
                formikHelpers.setSubmitting(false);
                return;
              }

              // if (!values.financialSettingsId && !hasPromoter) {
              //   toast({
              //     title: "Dados financeiros obrigatórios",
              //     description:
              //       "Por favor, preencha e salve os dados financeiros primeiro antes de salvar o Corban.",
              //     status: "error",
              //     duration: 5000,
              //     isClosable: true,
              //   });
              //   formikHelpers.setSubmitting(false);
              //   return;
              // }


              // const financialInvalid = isFinancialConfigurationInvalid(
              //   values,
              //   hasPromoter,
              //   false
              // );

              // console.log("CorbanForm:onSubmit financialInvalid", {
              //   financialInvalid,
              //   isFGTSEnable: values?.isFGTSEnable,
              //   isConsigEnable: values?.isConsigEnable,
              //   financialSettingsId: values?.financialSettingsId,
              //   paymentSplit: values?.paymentSplit,
              //   hasPromoter,
              // });

              // if (financialInvalid) {
              //   const toastId = "financial-settings-required";
              //   if (!toast.isActive || !toast.isActive(toastId)) {
              //     toast({
              //       id: toastId,
              //       title: "Dados financeiros obrigatórios",
              //       description:
              //         "Por favor, preencha e salve os dados financeiros primeiro antes de salvar o Corban.",
              //       status: "error",
              //       duration: 5000,
              //       isClosable: true,
              //       position: "top",
              //     });
              //   }

              //   formikHelpers.setSubmitting(false);
              //   return;
              // }

              const masterUserFields = [
                "masterUserName",
                "masterUserLastName",
                "masterUserCpf",
                "masterUserEmail",
                "masterUserPhone",
              ];

              const missingFields = masterUserFields.filter((field) => {
                const value = (values as any)[field];
                return !value || (Array.isArray(value) && value.length === 0);
              });

              if (missingFields.length > 0) {
                toast({
                  title: "Dados do usuário master incompletos",
                  description:
                    "Por favor, preencha todos os dados do usuário responsável pelo Corban antes de salvar.",
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
                formikHelpers.setSubmitting(false);
                return;
              }

              await onSubmit(values);
            }}
            validationSchema={CorbanFormValidationSchema(hasPromoter, isNew)}
          >
            {({ setFieldValue, setValues, values, isSubmitting }) => {
              const showFGTSContent = values.isFGTSEnable && (!hasPromoter || initialValues?.isFGTSEnablePromoter);
              const showConsigContent = values.isConsigEnable && (!hasPromoter || initialValues?.isConsigEnablePromoter);

              useEffect(() => {
                if (
                  roles.cannotCreateUser &&
                  roles.corbanWithoutPromoter &&
                  values.masterUserRole.length === 0
                ) {
                  setFieldValue("masterUserRole", [
                    hasPromoter ? roles.cannotCreateUser : roles.corbanWithoutPromoter,
                  ]);
                  setIsRoleSwitchEnabled(false);
                }
              }, [roles, values.masterUserRole.length, setFieldValue]);

              useEffect(() => {
                if (values.masterUserRole.length > 0) {
                  const userRoles: Role[] = values.masterUserRole;
                  setIsRoleSwitchEnabled(
                    userRoles.some((role) =>
                      role.permissions.includes(PermissionEnum.CREATE_USER)
                    )
                  );
                }
              }, [values.masterUserRole]);

              let order = [
                "ZERO TAC ZDC",
                "ZERO TAC",
                "LIGHT",
                "NORMAL",
                "POWER",
                "MAX",
                "ULTRA",
                "GRANATOK 1",
                "GRANATOK 2",
              ];

              if (isZeCredito) {
                order = order.reverse();
              }
              // const colorMap: Record<string, string> = {
              //   "GRANATOK 1": "red.300",
              //   "GRANATOK 2": "red.400",
              //   "ZERO TAC ZDC": "pink.400",
              //   "ZERO TAC": "blue.200",
              //   LIGHT: "secondary",
              //   NORMAL: "gray.400",
              //   POWER: "green.300",
              //   MAX: "yellow.400",
              //   ULTRA: "orange.400",
              // };

              return (
                <Form>
                  <VStack spacing={8} w="100%">
                    <Heading
                      fontFamily="Lexend Deca"
                      fontSize="2xl"
                      as="b"
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      Dados Corban
                    </Heading>

                    <Flex gap="2rem" width="100%">
                      <Field name="businessName">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.businessName &&
                              (form.touched.businessName)
                            }
                          >
                            <FormLabel>Nome Fantasia</FormLabel>
                            <Input
                              {...field}
                              type="text"
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                form.setFieldValue(field.name, value);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.businessName}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Flex>

                    <Flex gap="2rem" width="100%">
                      <Field name="legalName">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.legalName &&
                              (form.touched.legalName)
                            }
                          >
                            <FormLabel>Razão Social</FormLabel>
                            <Input
                              {...field}
                              type="text"
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                form.setFieldValue(field.name, value);
                              }}
                            />
                            <FormErrorMessage>{form.errors.legalName}</FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="document">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.document &&
                              (form.touched.document)
                            }
                          >
                            <FormLabel>CNPJ do Corban</FormLabel>
                            <Input
                              {...field}
                              maxLength={18}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (documentFormatter) {
                                  value = documentFormatter(value);
                                }
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                            />
                            <FormErrorMessage>{form.errors.document}</FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Flex>
                    <Flex
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Field name="commercialManagerId">
                        {({ field, form }: FieldProps) => {

                          const selectValue = field.value === null ? "null" : (field.value ?? "");

                          return (
                            <FormControl
                              isInvalid={
                                !!(
                                  form.errors.commercialManagerId &&
                                  form.touched.commercialManagerId

                                )
                              }
                            >
                              <FormLabel>Gerente Comercial</FormLabel>
                              <Select
                                {...field}
                                value={selectValue}
                                disabled={hasPromoter}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "null") {
                                    form.setFieldValue("commercialManagerId", null);
                                  } else {
                                    form.setFieldValue("commercialManagerId", val);
                                  }
                                }}
                              >
                                <option value="" disabled hidden>
                                  Selecione o Gerente Comercial
                                </option>
                                <option value="null"></option>
                                {commercialManagers.map((manager) => (
                                  <option key={manager.id} value={manager.id}>
                                    {manager.name} {manager.lastName}
                                  </option>
                                ))}
                              </Select>
                              <FormErrorMessage>
                                {form.errors.commercialManagerId as string}
                              </FormErrorMessage>
                            </FormControl>
                          );
                        }}
                      </Field>
                    </Flex>
                    <Heading
                      fontFamily="Lexend Deca"
                      fontSize="2xl"
                      as="b"
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      Vendedor Autorizado
                    </Heading>


                    <Flex gap="2rem" width="100%">
                      <Field name="sellerAuthorized">
                        {({ field, form }: any) => (
                          <CertifiedCpfSelector
                            corbanId={isNew ? undefined : values.id}
                            value={field.value?.replace(/\D/g, "") || ""}
                            onChange={(cpf) => {
                              form.setFieldValue(field.name, cpf);
                            }}
                            error={
                              form.touched.sellerAuthorized && form.errors.sellerAuthorized
                                ? form.errors.sellerAuthorized
                                : undefined
                            }
                            isDisabled={isNew}
                          />
                        )}
                      </Field>
                    </Flex>

                    <Heading
                      fontFamily="Lexend Deca"
                      fontSize="2xl"
                      as="b"
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      Produtos Habilitados:
                    </Heading>

                    <Divider borderColor="gray" borderWidth="1px" />

                    <FormControl display="flex" flexDirection="column" gap={3}>
                      <Box
                        display="flex"
                        justifyContent="left"
                        alignItems="center"
                        fontWeight="bold"
                        fontSize={20}
                        gap={3}
                      >
                        Habilitar FGTS
                        <Field name='isFGTSEnable'>
                          {({ field, form }: any) => (
                            <Switch
                              isDisabled={hasPromoter && !initialValues?.isFGTSEnablePromoter}
                              isChecked={
                                field.value &&
                                (!hasPromoter || initialValues?.isFGTSEnablePromoter)
                              }
                              onChange={(e) => {
                                form.setFieldValue("isFGTSEnable", e.target.checked)
                                setIsFGTSEnable(e.target.checked)
                              }}
                            >
                            </Switch>
                          )}
                        </Field>
                      </Box>

                      {showFGTSContent && (
                        <FormControl>
                          <Box
                            display="flex"
                            justifyContent="left"
                            alignItems="center"
                            gap={3}
                          >
                            Serviço via API
                            <Field name="isFGTSApiEnable">
                              {({ field, form }: any) => (
                                <Switch
                                  isChecked={field.value}
                                  onChange={(e) => {
                                    form.setFieldValue("isFGTSApiEnable", e.target.checked)
                                  }}
                                />
                              )}
                            </Field>
                          </Box>

                          {((initialValues?.isFGTSApiEnable && values?.isFGTSApiEnable) || (!initialValues?.isFGTSApiEnable && values?.isFGTSApiEnable)) && (
                            <FormControl
                              display="flex"
                              flexDirection='column'
                              gap={8}
                              my={4}
                              width='100%'
                            >
                              <Box width='100%'>
                                <FormLabel htmlFor="fgtsApikey">API Key</FormLabel>
                                <Flex gap={4} width='100%'>
                                  <InputGroup width='100%'>
                                    <Field name="fgtsApikey">
                                      {({ field }: FieldProps) => (
                                        <Input
                                          {...field}
                                          id="fgtsApikey"
                                          type={showApiKey ? "text" : "password"}
                                          placeholder={
                                            (isNew || values.isCreateAccessApiGranatechFgts) ? "Api Key será gerada automaticamente" : "*************************"
                                          }
                                          autoComplete="off"
                                          isReadOnly
                                          cursor="text"
                                          userSelect="text"
                                          bg="gray.50"
                                          // cursor="not-allowed"
                                          opacity={1}
                                          value={field.value || ""}
                                          pr="4.5rem"
                                          _readOnly={{
                                            bg: "gray.50",
                                            cursor: "text",
                                            userSelect: "text",
                                          }}
                                        />
                                      )}
                                    </Field>
                                    {!isNew && (
                                      <InputRightElement width="auto" marginRight={1}>
                                        <HStack spacing={1}>
                                          <IconButton
                                            aria-label={
                                              showApiKey
                                                ? "Ocultar API Key"
                                                : "Mostrar API Key"
                                            }
                                            icon={showApiKey ? <FaEyeSlash /> : <FaEye />}
                                            onClick={() => setShowApiKey(!showApiKey)}
                                            variant="ghost"
                                            size="sm"
                                          />
                                        </HStack>
                                      </InputRightElement>
                                    )}
                                  </InputGroup>

                                  {(initialValues.isFGTSApiEnable && !isNew) && (
                                    <Button
                                      colorScheme="primary"
                                      width="26%"
                                      px={20}
                                      onClick={() => handleResetFGTSApiKey(setFieldValue)}
                                    >
                                      Redefinir Api key
                                    </Button>
                                  )}
                                </Flex>
                              </Box>

                              <Flex
                                alignItems='flex-start'
                                gap={4}
                                width='100%'
                              >
                                <Box flex={1}>
                                  <Field name="fgtsWebhookUrl">
                                    {({ field, form }: any) => (
                                      <FormControl
                                        isInvalid={
                                          !!form.errors.fgtsWebhookUrl &&
                                          (Boolean(form.touched.fgtsWebhookUrl)) as boolean
                                        }
                                      >
                                        <FormLabel htmlFor="fgtsWebhookUrl">URL Callback/Webhook</FormLabel>
                                        <Input
                                          {...field}
                                          id="fgtsWebhookUrl"
                                          type="text"
                                          placeholder="https://www.meuwebhook.com.br/event"
                                          autoComplete="off"
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            form.setFieldValue("fgtsWebhookUrl", value);
                                          }}
                                          onBlur={(e) => {
                                            form.setFieldTouched("fgtsWebhookUrl", true);
                                            field.onBlur(e);
                                          }}
                                        />
                                        <FormErrorMessage>
                                          {form.errors.fgtsWebhookUrl}
                                        </FormErrorMessage>
                                      </FormControl>
                                    )}
                                  </Field>
                                </Box>

                                <Box flex={1}>
                                  <FormControl>
                                    <FormLabel>Token Callback/Webhook</FormLabel>
                                    <InputGroup>
                                      <Field
                                        as={Input}
                                        id={'fgtsToken'}
                                        name="fgtsToken"
                                        type="text"
                                        placeholder="xxxxxxx-xxxxxxx-xxxxxxx-xxxxxxx-xxxxxxx"
                                        autoComplete="off"
                                      />
                                    </InputGroup>
                                  </FormControl>
                                </Box>

                                {(!isNew && !values.isCreateAccessApiGranatechFgts) && (
                                  <Box flexShrink={0} pt={8}>
                                    <Button
                                      colorScheme="primary"
                                      px={20}
                                      onClick={() => handleResetFGTSWebhook(values)}
                                      isLoading={isUpdatingFgtsWebhook}
                                      loadingText="Atualizando"
                                    >
                                      Atualizar Webhook
                                    </Button>
                                  </Box>
                                )}
                              </Flex>
                            </FormControl>
                          )}

                          <Box width="100%" overflowX="auto" my={6}>
                            <Table
                              colorScheme="gray"
                              width="60rem"
                              maxWidth="100%"
                              mx="auto"
                            >
                              <Thead>
                                <Tr>
                                  <Th textAlign="center">Nome do Produto</Th>
                                  <Th textAlign="center">Comissão</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {products &&
                                  products
                                    .sort((a, b) => {
                                      let order = [
                                        "ZERO TAC ZDC",
                                        "ZERO TAC",
                                        "LIGHT",
                                        "NORMAL",
                                        "POWER",
                                        "MAX",
                                        "ULTRA",
                                        "GRANATOK 1",
                                        "GRANATOK 2",
                                      ];

                                      if (isZeCredito) {
                                        order = order.reverse();
                                      }
                                      return (
                                        order.indexOf(a.name) - order.indexOf(b.name)
                                      );
                                    })
                                    .map((product) => {
                                      const colorMap: Record<string, string> = {
                                        "ZERO TAC ZDC": "pink.400",
                                        "GRANATOK 1": "red.300",
                                        "GRANATOK 2": "red.400",
                                        "ZERO TAC": "blue.200",
                                        LIGHT: "blue.700",
                                        NORMAL: "gray.400",
                                        POWER: "green.300",
                                        MAX: "yellow.400",
                                        ULTRA: "orange.400",
                                      };
                                      const rowColor = colorMap[product.name];
                                      return (
                                        <Tr key={product.id} bg={rowColor}>
                                          <Td textAlign="center" color="white">
                                            {product.name}
                                          </Td>
                                          <Td textAlign="center" color="white">
                                            {parseFloat(
                                              (product.partnerPercentage! * 100).toFixed(
                                                3
                                              )
                                            )}
                                            %
                                          </Td>
                                        </Tr>
                                      );
                                    })}
                              </Tbody>
                            </Table>
                            {(isFGTSProductsLoading && products.length === 0) && (
                              <Flex width='100%' justifyContent='center' mt={4}>
                                <Spinner color="primary" size="lg" speed="0.65s" />
                              </Flex>
                            )}
                          </Box>
                        </FormControl>
                      )}
                      <Box
                        display="flex"
                        justifyContent="left"
                        alignItems="center"
                        fontWeight="bold"
                        fontSize={20}
                        gap={3}
                      >
                        Consignado CLT
                        <Field name="isConsigEnable">
                          {({ field, form }: any) => (
                            <Switch
                              isDisabled={hasPromoter && !initialValues?.isConsigEnablePromoter}
                              isChecked={
                                field.value &&
                                (!hasPromoter || initialValues?.isConsigEnablePromoter)
                              }
                              onChange={(e) => {
                                form.setFieldValue("isConsigEnable", e.target.checked)
                                setIsConsigEnable(e.target.checked);
                              }}
                            />
                          )}
                        </Field>
                      </Box>

                      {showConsigContent && (
                        <FormControl>
                          <Box
                            display="flex"
                            justifyContent="left"
                            alignItems="center"
                            gap={3}
                          >
                            Serviço via API
                            <Field name="isConsigApiEnable">
                              {({ field, form }: any) => (
                                <Switch
                                  isChecked={field.value}
                                  onChange={(e) => {
                                    form.setFieldValue("isConsigApiEnable", e.target.checked)
                                  }}
                                />
                              )}
                            </Field>
                          </Box>

                          {((initialValues?.isConsigApiEnable && values?.isConsigApiEnable) || (!initialValues?.isConsigApiEnable && values?.isConsigApiEnable)) && (
                            <FormControl
                              display="flex"
                              flexDirection='column'
                              gap={8}
                              my={4}
                              width='100%'
                            >
                              <Box width='100%'>
                                <FormLabel htmlFor="consigApikey">API Key</FormLabel>
                                <Flex gap={4}>
                                  <InputGroup>
                                    <Field name="consigApikey">
                                      {({ field }: FieldProps) => (
                                        <Input
                                          {...field}
                                          id="consigApikey"
                                          type={showConsigApiKey ? "text" : "password"}
                                          placeholder={
                                            (isNew || values.isCreateAccessApiGranatechConsig) ? "Api Key será gerada automaticamente" : "*************************"
                                          }
                                          autoComplete="off"
                                          isReadOnly
                                          cursor="text"
                                          userSelect="text"
                                          bg="gray.50"
                                          opacity={1}
                                          value={field.value || ""}
                                          pr="4.5rem"
                                          _readOnly={{
                                            bg: "gray.50",
                                            cursor: "text",
                                            userSelect: "text",
                                          }}
                                        />
                                      )}
                                    </Field>

                                    {!isNew && (
                                      <InputRightElement width="auto" marginRight={1}>
                                        <HStack spacing={1}>
                                          {/* <Tooltip label='Redefinir API Key' placement='top'>
                                            <IconButton
                                              aria-label="Redefinir API Key"
                                              icon={<FaRedo />}
                                              onClick={() => handleResetConsigApiKey(setFieldValue)}
                                              variant="ghost"
                                              size="sm"
                                              colorScheme="blue"
                                            />
                                          </Tooltip> */}
                                          <IconButton
                                            aria-label={
                                              showConsigApiKey
                                                ? "Ocultar API Key"
                                                : "Mostrar API Key"
                                            }
                                            icon={
                                              showConsigApiKey ? <FaEyeSlash /> : <FaEye />
                                            }
                                            onClick={() => setConsigApiKey(!showConsigApiKey)}
                                            variant="ghost"
                                            size="sm"
                                          />
                                        </HStack>
                                      </InputRightElement>
                                    )}
                                  </InputGroup>

                                  {(initialValues.isConsigApiEnable && !isNew) && (
                                    <Button
                                      colorScheme="primary"
                                      width="23%"
                                      px={20}
                                      onClick={() => handleResetConsigApiKey(setFieldValue)}
                                    >
                                      Redefinir API Key
                                    </Button>
                                  )}
                                </Flex>
                              </Box>

                              <Flex
                                alignItems='flex-start'
                                gap={4}
                                width='100%'
                              >
                                <Box flex={1}>
                                  <Field name="consigWebhookUrl">
                                    {({ field, form }: any) => (
                                      <FormControl
                                        isInvalid={
                                          !!form.errors.consigWebhookUrl &&
                                          (Boolean(form.touched.consigWebhookUrl)) as boolean
                                        }
                                      >
                                        <FormLabel htmlFor="consigWebhookUrl">URL Callback/Webhook</FormLabel>
                                        <Input
                                          {...field}
                                          id="consigWebhookUrl"
                                          type="text"
                                          placeholder="https://www.meuwebhook.com.br/event"
                                          autoComplete="off"
                                          onBlur={(e) => {
                                            form.setFieldTouched("consigWebhookUrl", true);
                                            field.onBlur(e);
                                          }}
                                        />
                                        <FormErrorMessage>
                                          {form.errors.consigWebhookUrl}
                                        </FormErrorMessage>
                                      </FormControl>
                                    )}
                                  </Field>
                                </Box>

                                <Box flex={1}>
                                  <FormControl>
                                    <FormLabel htmlFor="consigToken">Token Callback/Webhook</FormLabel>
                                    <InputGroup>
                                      <Field
                                        as={Input}
                                        id={'consigToken'}
                                        name="consigToken"
                                        type="text"
                                        placeholder="xxxxxxx-xxxxxxx-xxxxxxx-xxxxxxx-xxxxxxx"
                                        autoComplete="off"
                                      />
                                    </InputGroup>
                                  </FormControl>
                                </Box>

                                {(!isNew && !values.isCreateAccessApiGranatechConsig) && (
                                  <Box flexShrink={0} pt={8}>
                                    <Button
                                      colorScheme="primary"
                                      px={20}
                                      onClick={() => handleResetConsigWebhook(values)}
                                      isLoading={isUpdatingConsigWebhook}
                                      loadingText="Atualizando"
                                    >
                                      Atualizar Webhook
                                    </Button>
                                  </Box>
                                )}
                              </Flex>
                            </FormControl>
                          )}

                          <Box width="100%" overflowX="auto" my={6}>
                            <Table
                              colorScheme="gray"
                              width="60rem"
                              maxWidth="100%"
                              mx="auto"
                            >
                              <Thead>
                                <Tr>
                                  <Th textAlign="center">Nome do Produto</Th>
                                  <Th textAlign="center">Comissão</Th>
                                  {/* <Th textAlign="center">Selecionar</Th> */}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {consigProducts &&
                                  consigProducts.map((product) => {
                                    return (
                                      <Tr key={product.id} bg={product.cor}>
                                        <Td textAlign="center" color="white">
                                          {product.nome}
                                        </Td>
                                        <Td textAlign="center" color="white">
                                          {product?.comissao! ? parseFloat(
                                            `${(product?.comissao! * 100).toFixed(3)}%`
                                          ) : '-'}
                                        </Td>
                                        {/* <Td textAlign="center">
                                          <Field name="consigProducts">
                                            {({ form }: any) => {
                                              const isChecked =
                                                form.values.consigProducts?.some(
                                                  (p: ConsigProductCorbans) =>
                                                    p.productId === product?.id
                                                );

                                              const handleChange = () => {
                                                if (isChecked) {
                                                  const updatedProducts =
                                                    form.values.consigProducts.filter(
                                                      (p: ConsigProductCorbans) =>
                                                        p.productId !== product.id
                                                    );
                                                  form.setFieldValue(
                                                    "consigProducts",
                                                    updatedProducts
                                                  );
                                                  setSelectedConsigProducts(
                                                    updatedProducts
                                                  );
                                                } else {
                                                  const newProduct = {
                                                    productId: product.id,
                                                    corbanId: initialValues.id,
                                                    ...product,
                                                  };
                                                  const newProducts = [
                                                    ...(form.values.consigProducts || []),
                                                    newProduct,
                                                  ];
                                                  form.setFieldValue(
                                                    "consigProducts",
                                                    newProducts
                                                  );
                                                  setSelectedConsigProducts(newProducts);
                                                }
                                              };

                                              return (
                                                <Checkbox
                                                  colorScheme="green"
                                                  isChecked={isChecked}
                                                  onChange={handleChange}
                                                />
                                              );
                                            }}
                                          </Field>
                                        </Td> */}
                                      </Tr>
                                    );
                                  })}
                              </Tbody>
                            </Table>
                            {(isConsigProductsLoading && consigProducts.length === 0) && (
                              <Flex width='100%' justifyContent='center' mt={4}>
                                <Spinner color="primary" size="lg" speed="0.65s" />
                              </Flex>
                            )}
                          </Box>
                        </FormControl>
                      )}
                    </FormControl>

                    {/* {!isNew && (
                      <Flex justify="center">
                        <Button
                          colorScheme="primary"
                          width="19rem"
                          loadingText="Salvando"
                          isLoading={isSavingProducts}
                          onClick={() => updateCreditTypeCorban(values)}
                        >
                          {"Salvar configurações de produtos"}
                        </Button>
                      </Flex>
                    )} */}

                    <Heading
                      fontFamily="Lexend Deca"
                      fontSize="2xl"
                      as="b"
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      Usuário master desse Corban
                    </Heading>

                    <Flex gap="2rem" width="100%">
                      <Field name="masterUserName">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.masterUserName &&
                              (form.touched.masterUserName)
                            }
                          >
                            <FormLabel>Nome do responsável</FormLabel>
                            <Input
                              {...field}
                              type="text"
                              placeholder="Nome"
                              autoComplete="off"
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                form.setFieldValue(field.name, value);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.masterUserName}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="masterUserLastName">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.masterUserLastName &&
                              (form.touched.masterUserLastName)
                            }
                          >
                            <FormLabel>Sobrenome do responsável</FormLabel>
                            <Input
                              {...field}
                              type="text"
                              placeholder="Sobrenome"
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                form.setFieldValue(field.name, value);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.masterUserLastName}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="masterUserPhone">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.masterUserPhone &&
                              (form.touched.masterUserPhone)
                            }
                          >
                            <FormLabel>Telefone</FormLabel>
                            <Input
                              type="tel"
                              placeholder="(00) 00000-0000"
                              maxLength={15}
                              value={field.value || ""}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (formatPhone) {
                                  value = formatPhone(value);
                                }
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => form.setFieldTouched(field.name, true)}
                            />
                            <FormErrorMessage>
                              {form.errors.masterUserPhone}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Flex>

                    <Flex gap="2rem" width="100%">
                      <Field name="masterUserEmail">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.masterUserEmail &&
                              (form.touched.masterUserEmail)
                            }
                          >
                            <FormLabel>Email</FormLabel>
                            <Input
                              {...field}
                              type="email"
                              placeholder="email@exemplo.com"
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.masterUserEmail}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="masterUserCpf">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              !!form.errors.masterUserCpf &&
                              (form.touched.masterUserCpf)
                            }
                          >
                            <FormLabel>CPF</FormLabel>
                            <Input
                              {...field}
                              type="tel"
                              placeholder="000.000.000-00"
                              maxLength={14}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (cpfFormatter) {
                                  value = cpfFormatter(value);
                                }
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={(e) => {
                                form.setFieldTouched(field.name, true);
                                field.onBlur(e);
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.masterUserCpf}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Flex>

                    <Flex direction="column" width="100%" gap="1rem">
                      <Flex width="100%" gap="2rem" align="flex-start">
                        <Box width="40%">
                          <Field name="masterUserPassword">
                            {({ field, form }: any) => (
                              <FormControl
                                isInvalid={
                                  !!form.errors.masterUserPassword &&
                                  (form.touched.masterUserPassword)
                                }
                              >
                                <FormLabel htmlFor={field.name}>Senha</FormLabel>
                                <InputGroup>
                                  <Input
                                    {...field}
                                    id={field.name}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="********"
                                    onBlur={(e) => {
                                      form.setFieldTouched(field.name, true);
                                      field.onBlur(e);
                                    }}
                                  />
                                  <InputRightElement>
                                    <IconButton
                                      aria-label={
                                        showPassword ? "Ocultar senha" : "Mostrar senha"
                                      }
                                      icon={showPassword ? <FaEyeSlash /> : <FaEye />}
                                      onClick={() => setShowPassword(!showPassword)}
                                      variant="ghost"
                                      size="sm"
                                    />
                                  </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage>
                                  {form.errors.masterUserPassword}
                                </FormErrorMessage>
                              </FormControl>
                            )}
                          </Field>
                        </Box>

                        <Flex
                          width="60%"
                          justify="flex-start"
                          align="center"
                          mt="2rem"
                          gap="3rem"
                        >
                          {hasPromoter && (
                            <Flex align="center" gap="0.5rem">
                              <FormLabel htmlFor="masterRole" mb="0">
                                Pode criar usuários
                              </FormLabel>
                              <Switch
                                id="masterRole"
                                isChecked={isRoleSwitchEnabled}
                                onChange={(e) => {
                                  setIsRoleSwitchEnabled(e.target.checked);
                                  const newRole = e.target.checked
                                    ? roles.canCreateUser
                                    : roles.cannotCreateUser;
                                  if (newRole) {
                                    setFieldValue("masterUserRole", [newRole]);
                                  }
                                }}
                              />
                            </Flex>
                          )}

                          <Flex align="center" gap="0.5rem">
                            <FormLabel htmlFor="automaticApproval" mb="0">
                              Aprovação Automática
                            </FormLabel>
                            <Switch
                              id="automaticApproval"
                              name="automaticApproval"
                              isChecked={values.automaticApproval}
                              onChange={(e) =>
                                setFieldValue("automaticApproval", e.target.checked)
                              }
                            />
                          </Flex>
                        </Flex>
                      </Flex>
                    </Flex>

                    <Divider />

                    {/* {hasPromoter && (
                      <Flex gap="1rem" width="100%" alignItems="center">
                        <FormLabel htmlFor="paymentSplit">Split de pagamento:</FormLabel>
                        <Switch
                          id="splitPagamento"
                          isChecked={values.paymentSplit}
                          onChange={(e) =>
                            setFieldValue("paymentSplit", e.target.checked)
                          }
                        />
                      </Flex>
                    )} */}

                    {(values.paymentSplit || !hasPromoter) && (
                      <VStack w="100%">
                        {(values?.isFGTSEnable || values?.isConsigEnable) && (
                          <>
                            <Flex
                              width="100%"
                              alignItems="center"
                              justifyContent="space-between"
                              mb={4}
                            >
                              <Heading fontFamily="Lexend Deca" fontSize="2xl" as="b">
                                Configurações Financeiras
                              </Heading>
                            </Flex>

                            <FinancialSettingsForm
                              isNew={isNew || !(values.FinancialSettings) || (!initialValues.financialSettingsCorban && !isNew)}
                              initialData={{
                                ...(values.FinancialSettings),
                                commission: values.commission,
                              }}
                              corbanId={values.id}
                              onSubmit={(data) => {
                                const updatedValues: any = {
                                  ...values,
                                  commission: data.commission,
                                  financialSettingsId: data.financialSettingsId,
                                };
                                updatedValues.financialSettingsId = data.financialSettingsId;
                                setValues(updatedValues, false);
                              }}
                              hasPromoter={hasPromoter}
                              banks={banks}
                              loadingBanks={loadingBanks}
                              commercialManagerProp={commercialManagerId}
                              document={values.document}
                              commercialManagerId={values.commercialManagerId}
                            />

                            <Divider />
                          </>
                        )}


                      </VStack>
                    )}

                    <Divider />

                    <Flex gap="1rem" width="100%" alignItems="center">
                      <FormLabel htmlFor="whiteLabelSwitch">É white label</FormLabel>
                      <Switch
                        id="whiteLabelSwitch"
                        isChecked={isWhiteLabelEnabled}
                        onChange={(e) => setIsWhiteLabelEnabled(e.target.checked)}
                      />
                    </Flex>

                    {isWhiteLabelEnabled && (
                      <VStack w="100%" spacing={8}>
                        <Heading
                          fontFamily="Lexend Deca"
                          fontSize="2xl"
                          as="b"
                          gap="2rem"
                          width="100%"
                          alignItems="flex-start"
                          mt={6}
                        >
                          White Label
                        </Heading>
                        <WhiteLabelForm
                          isNew={values.whiteLabelId === undefined}
                          initialData={{
                            ...values.WhiteLabel,
                            corbanId: values.id,
                          }}
                          onSubmit={(data) => {
                            setFieldValue("whiteLabelId", data.whiteLabelId);
                          }}
                        />
                      </VStack>
                    )}

                    <Flex justify="center" direction="column" align="center">
                      <Button
                        colorScheme="green"
                        type="submit"
                        variant="outline"
                        width="16rem"
                        isDisabled={!isNew && isFinancialConfigurationInvalid(values, hasPromoter, isSubmitting)|| (isNew && values.paymentSplit && !values.financialSettingsId)}
                        isLoading={isSubmitting}
                        loadingText="Salvando"
                      >
                        {isNew ? "Cadastrar Corban" : "Salvar Alterações"}
                      </Button>

                      {values.isFGTSEnable || values.isConsigEnable && ((!hasPromoter && !values.financialSettingsId) || (hasPromoter && values.paymentSplit && !values.financialSettingsId)) && (
                        <Box color="red.500" fontSize="sm" mt={2} textAlign="center">
                          Salve os dados financeiros primeiro
                        </Box>
                      )}
                    </Flex>
                  </VStack>
                </Form>
              );
            }}
          </Formik>
        </CardBody>
      </Card>
    </Flex>
  );
}
